import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ContentComponent } from './shared/components/layout/content/content.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { QrscannerComponent } from './components/qrscanner/qrscanner.component';
import { QrScannerListComponent } from './components/qrscanner/qr-scanner-list/qr-scanner-list/qr-scanner-list.component';
import { QrScannerDetailComponent } from './components/qrscanner/qr-scanner-detail/qr-scanner-detail.component';
import { ConfigurationV2Component } from './components/configuration-v2/configuration-v2.component';

export const routes: Routes = [
    {
        path: "",
        redirectTo: "/auth/login",
        pathMatch: "full"
    },
    {
        path: "auth",
        loadChildren: () => import("@/app/components/auth/auth.module").then(m => m.AuthModule)
    },
    {
        path: "",
        component: ContentComponent,
        children: [
            {
                path: "dashboard",
                loadChildren: () => import("@/app/components/dashboard/dashboard.module").then(m => m.DashboardModule)
            },
            {
                path: "product",
                loadChildren: () => import("@/app/components/product/product.module").then(m => m.ProductModule)
            },
            {
                path: "product-v2",
                loadChildren: () => import("@/app/components/product-v2/product-v2.module").then(m => m.ProductV2Module)
            },
            {
                path: "pricing-v2",
                loadChildren: () => import("@/app/components/pricing-v2/pricing-v2.module").then(m => m.PricingV2Module)
            },
            {
                path: "user",
                loadChildren: () => import("@/app/components/user/user.module").then(m => m.UserModule)
            },
            {
                path: "order",
                loadChildren: () => import("@/app/components/order/order.module").then(m => m.OrderModule)
            },
            {
                path: "three-pl",
                loadChildren: () => import("@/app/components/three-pl/three-pl.module").then(m => m.ThreePlModule)
            },
            {
                path: "role",
                loadChildren: () => import("@/app/components/role/role.module").then(m => m.RoleModule)
            },
            {
                path: "article",
                loadChildren: () => import("@/app/components/article/article.module").then(m => m.ArticleModule),
            },
            {
                path: 'sale',
                loadChildren: () => import("@/app/components/sale/sale.module").then(m => m.SaleModule),
            },
            {
                path: 'voucher',
                loadChildren: () => import("@/app/components/sale/voucher/voucher.module").then(m => m.VoucherModule),
            },
            {
                path: 'report',
                loadChildren: () => import("@/app/components/report/report.module").then(m => m.ReportModule),
            },
            {
              path: 'mission',
              loadChildren: () => import("@/app/components/mission/mission.module").then(m => m.MissionModule),
            },
            {
                path: 'configuration',
                loadChildren: () => import("@/app/components/configuration/configuration.module").then(m => m.ConfigurationModule),
            },
            {
                path: 'notification',
                loadChildren: () => import("@/app/components/notification/notification.module").then(m => m.NotificationModule),
            },
            {
                path: 'promotion-configuration',
                loadChildren: () => import("@/app/components/promotion-configuration/promotion-configuration.module").then(m => m.PromotionConfigurationModule),
            },
            {
                path: 'promotion-landing-page',
                loadChildren: () => import("@/app/components/promotion-landing-page/promotion-landing-page.module").then(m => m.PromotionLandingPageModule),
            },
            {
                path: 'banner-configuration',
                loadChildren: () => import("@/app/components/banner-configuration/banner-configuration.module").then(m => m.BannerConfigurationModule),
            },
            {
                path: 'widget',
                loadChildren: () => import("@/app/components/widget/widget.module").then(m => m.WidgetModule),
            },
            {
                path: 'search-rule',
                loadChildren: () => import("@/app/components/search-rule/search-rule.module").then(m => m.SearchRuleModule),
            },
            {
                path: 'job',
                loadChildren: () => import("@/app/components/job-status/job-status-routing.module").then(m => m.JobStatusRoutingModule),
            },
            {
                path: 'minigame-config',
                loadChildren: () => import("@/app/components/minigame-configuration/minigame.module").then(m => m.MinigameModule),
            },
            {
                path: 'notification',
                loadChildren: () => import("@/app/components/notification/notification.module").then(m => m.NotificationModule),
            },
            {
                path: 'configuration-v2',
                loadChildren: () => import("@/app/components/configuration-v2/configuration-v2.module").then(m => m.ConfigurationV2Module)
            },
            {
                path: 'membership-programs',
                loadChildren: () => import("@/app/components/membership-programs/membership-programs/membership-programs.module").then(m => m.MembershipProgramModule)
            },
            {
                path: 'qr-scanner',
                component: QrscannerComponent
            },
            {
                path: 'qr-scanner/list',
                component: QrScannerListComponent
            },
            {
                path: 'qr-scanner/detail',
                component: QrScannerDetailComponent
            },
            {
                path: 'tool',
                loadChildren: () => import('./components/tool/tool.module').then(m => m.ToolModule)
            },
            {
                path: 'return-order',
                loadChildren: () => import("@/app/components/return-order/return-order.module").then(m => m.ReturnOrderModule),
            },
            {
                path: 'user-wallet',
                loadChildren: () => import("@/app/components/user/user-wallet/user-wallet.module").then(m => m.UserWalletModule),
            },
            {
                path: 'import-order',
                loadChildren: () => import("@/app/components/import-order/import-order.module").then(m => m.ImportOrderModule),
            },
            {
                path: 'import-cs-staff',
                loadChildren: () => import("@/app/components/import-cs-staff/import-cs-staff.module").then(m => m.ImportCsStaffModule),
            },
            {
                path: 'faq',
                loadChildren: () => import("@/app/components/faq/faq.module").then(m => m.FaqModule),
            },
            {
                path: 'purchase-request',
                loadChildren: () => import("@/app/components/purchase-request/purchase-request.module").then(m => m.PurchaseRequestModule),
            },
            {
                path: 'data-labeling',
                loadChildren: () => import("@/app/components/data-labeling/data-labeling.module").then(m => m.DataLabelingModule),
            }
        ]
    }
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes, {
            initialNavigation: "enabledBlocking",
            scrollPositionRestoration: 'enabled',
        })
    ],
    exports: [RouterModule]
})
export class AppRoutingModule { }
